import React from 'react';
export const Banner110DataSource = {
  OverPack: { className: 'home-page-wrapper banner11-wrapper' },
  bg: {
    name: 'bg',
    children:
      'https://static.cecloud.com/tizan/public-read/image/1617960872167.png',
    className: 'title-image',
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        isSearchable: true,
        children: (
          <span>
            <p>飞思AI中台PhyThink</p>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'content~kna43yhneel',
        className: '',
        children: (
          <span>
            <p>
              中国系统持续探索先进的人工智能技术，实现在数据科学领域的沉淀融合与创新应用，打造了城市级全栈式人工智能平台。PhyThink是一站式模型开发创新与综合服务的云原生人工智能平台，提供数据处理、模型训练、模型管理和模型服务的全栈式AI能力，助力数字化转型，加速人工智能技术与行业应用的融合发展
            </p>
          </span>
        ),
      },
    ],
  },
};
export const Content550DataSource = {
  wrapper: { className: 'home-page-wrapper content55-wrapper' },
  page: { className: 'home-page content55' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [{ name: 'title', children: '一站式AI基础平台，全生命周期管理' }],
  },
  bg: {
    className: 'content55-bg',
    children:
      'https://static.cecloud.com/tizan/public-read/images/二级人工智能-2.png',
  },
  block: {
    className: 'block-wrapper',
    children: [
      {
        name: 'content0',
        className: 'block',
        md: 24,
        xs: 24,
        children: {
          block: {
            children: [
              {
                name: 'block0',
                className: 'block0',
                titlewrapper: {
                  children: [
                    {
                      name: 'image',
                      className: 'block0-image',
                      children:
                        'https://static.cecloud.com/tizan/public-read/images/数据准备@2x.png',
                    },
                    {
                      name: 'title',
                      className: 'block0-title',
                      children: '数据准备',
                    },
                  ],
                },
              },
              {
                name: 'block1',
                className: 'block1',
                titlewrapper: {
                  children: [
                    {
                      name: 'title',
                      className: 'block1-title',
                      children: '数据处理中心',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content',
                      className: 'block1-content',
                      children:
                        '汇聚海量数据，经过数据清洗、加工后用于模型训练，提供统一的数据预处理能力。',
                    },
                  ],
                },
              },
              {
                name: 'block2',
                className: 'block2',
                titlewrapper: {
                  children: [
                    {
                      name: 'title',
                      className: 'block2-title',
                      children: '模型创新中心',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content',
                      className: 'block2-content',
                      children:
                        '面向AI开发者，提供数据预处理、特征工程、模型设计、模型训练到模型部署的一站式AI模型研发创新平台。',
                    },
                  ],
                },
              },
              {
                name: 'block3',
                className: 'block3',
                titlewrapper: {
                  children: [
                    {
                      name: 'title',
                      className: 'block3-title',
                      children: '模型训练',
                    },
                    {
                      name: 'image',
                      className: 'block3-image',
                      children:
                        'https://static.cecloud.com/tizan/public-read/images/模型训练@2x.png',
                    },
                  ],
                },
              },
            ],
          },
        },
      },
      {
        name: 'content1',
        className: 'block',
        md: 24,
        xs: 24,
        children: {
          block: {
            children: [
              {
                name: 'block0',
                className: 'block0',
                titlewrapper: {
                  children: [
                    {
                      name: 'image',
                      className: 'block0-image',
                      children:
                        'https://static.cecloud.com/tizan/public-read/images/模型训练@2x.png',
                    },
                    {
                      name: 'title',
                      className: 'block0-title',
                      children: '数据准备',
                    },
                  ],
                },
              },
              {
                name: 'block1',
                className: 'block1',
                titlewrapper: {
                  children: [
                    {
                      name: 'title',
                      className: 'block1-title',
                      children: '数据处理中心',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content',
                      className: 'block1-content',
                      children:
                        '汇聚海量数据，经过数据清洗、加工后用于模型训练，提供统一的数据预处理能力。',
                    },
                  ],
                },
              },
              {
                name: 'block2',
                className: 'block2',
                titlewrapper: {
                  children: [
                    {
                      name: 'title',
                      className: 'block2-title',
                      children: '模型创新中心',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content',
                      className: 'block2-content',
                      children:
                        '面向AI开发者，提供数据预处理、特征工程、模型设计、模型训练到模型部署的一站式AI模型研发创新平台。',
                    },
                  ],
                },
              },
              {
                name: 'block3',
                className: 'block3',
                titlewrapper: {
                  children: [
                    {
                      name: 'title',
                      className: 'block3-title',
                      children: '模型训练',
                    },
                    {
                      name: 'image',
                      className: 'block3-image',
                      children:
                        'https://static.cecloud.com/tizan/public-read/images/模型训练@2x.png',
                    },
                  ],
                },
              },
            ],
          },
        },
      },
      {
        name: 'content2',
        className: 'block',
        md: 24,
        xs: 24,
        children: {
          block: {
            children: [
              {
                name: 'block0',
                className: 'block0',
                titlewrapper: {
                  children: [
                    {
                      name: 'image',
                      className: 'block0-image',
                      children:
                        'https://static.cecloud.com/tizan/public-read/images/模型管理@2x.png',
                    },
                    {
                      name: 'title',
                      className: 'block0-title',
                      children: '模型管理',
                    },
                  ],
                },
              },
              {
                name: 'block1',
                className: 'block1',
                titlewrapper: {
                  children: [
                    {
                      name: 'title',
                      className: 'block1-title',
                      children: '智能资产中心',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content',
                      className: 'block1-content',
                      children:
                        '针对各类智能场景需求驱动下的模型成果，进行资产化管理，构建与研发人工智能平台模型算法库和数据样本资产库。',
                    },
                  ],
                },
              },
              {
                name: 'block2',
                className: 'block2',
                titlewrapper: {
                  children: [
                    {
                      name: 'title',
                      className: 'block2-title',
                      children: 'AI服务中心',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content',
                      className: 'block2-content',
                      children:
                        '以模型服务集市的形式，聚合6大模型能力快速接入，统一管理、调度服务和资源，集成AI服务组件，提供标准化接口。',
                    },
                  ],
                },
              },
              {
                name: 'block3',
                className: 'block3',
                titlewrapper: {
                  children: [
                    {
                      name: 'title',
                      className: 'block3-title',
                      children: '模型服务',
                    },
                    {
                      name: 'image',
                      className: 'block3-image',
                      children:
                        'https://static.cecloud.com/tizan/public-read/images/模型服务@2x.png',
                    },
                  ],
                },
              },
            ],
          },
        },
      },
      {
        name: 'content3',
        className: 'block',
        md: 24,
        xs: 24,
        children: {
          block: {
            children: [
              {
                name: 'block0',
                className: 'block0',
                titlewrapper: {
                  children: [
                    {
                      name: 'image',
                      className: 'block0-image',
                      children:
                        'https://static.cecloud.com/tizan/public-read/images/模型管理@2x.png',
                    },
                    {
                      name: 'title',
                      className: 'block0-title',
                      children: '模型管理',
                    },
                  ],
                },
              },
              {
                name: 'block1',
                className: 'block1',
                titlewrapper: {
                  children: [
                    {
                      name: 'title',
                      className: 'block1-title',
                      children: '智能资产中心',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content',
                      className: 'block1-content',
                      children:
                        '针对各类智能场景需求驱动下的模型成果，进行资产化管理，构建与研发人工智能平台模型算法库和数据样本资产库。',
                    },
                  ],
                },
              },
              {
                name: 'block2',
                className: 'block2',
                titlewrapper: {
                  children: [
                    {
                      name: 'title',
                      className: 'block2-title',
                      children: 'AI服务中心',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content',
                      className: 'block2-content',
                      children:
                        '以模型服务集市的形式，聚合6大模型能力快速接入，统一管理、调度服务和资源，集成AI服务组件，提供标准化接口。',
                    },
                  ],
                },
              },
              {
                name: 'block3',
                className: 'block3',
                titlewrapper: {
                  children: [
                    {
                      name: 'title',
                      className: 'block3-title',
                      children: '模型服务',
                    },
                    {
                      name: 'image',
                      className: 'block3-image',
                      children:
                        'https://static.cecloud.com/tizan/public-read/images/模型服务@2x.png',
                    },
                  ],
                },
              },
            ],
          },
        },
      },
    ],
  },
};
export const Content570DataSource = {
  wrapper: { className: 'home-page-wrapper content57-wrapper' },
  page: { className: 'home-page content57' },
  OverPack: { playScale: 0.3, className: '' },
  bg: {
    className: 'content57-bg',
    children:
      'https://static.cecloud.com/tizan/public-read/images/二级人工智能-3.png',
  },
  block: {
    className: 'block-wrapper',
    children: [
      {
        name: 'content0',
        className: 'block',
        md: 24,
        xs: 24,
        title: {
          className: 'content-title',
          children: '5大核心技术，安全稳定高效',
        },
        children: {
          block: {
            children: [
              {
                name: 'block01',
                className: 'block-box',
                md: 8,
                xs: 24,
                children: {
                  children: [
                    {
                      name: 'title',
                      className: 'block-title',
                      children: '一站式自动学习',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content0',
                      className: 'block-content',
                      children:
                        '结合自动数据增强、网络结构搜索、自动调参等AutoML领域前沿技术，最大程度节省算法工程师低效工时投入，加速模型场景化落地',
                    },
                    {
                      name: 'content1',
                      className: 'block-content',
                      children: '',
                    },
                  ],
                },
              },
              {
                name: 'block02',
                className: 'block-box',
                md: 8,
                xs: 24,
                children: {
                  children: [
                    {
                      name: 'title',
                      className: 'block-title',
                      children: '异构AI芯片支持',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content0',
                      className: 'block-content',
                      children:
                        '支持CPU、GPU、TPU、MLU等多种类型AI芯片调度，并提供底层硬件加速能力。同时兼容X86和ARM两种主流CPU架构，全面支撑国产化适配，保障安全可信。',
                    },
                    {
                      name: 'content1',
                      className: 'block-content',
                      children: '',
                    },
                  ],
                },
              },
              {
                name: 'block03',
                className: 'block-box',
                md: 8,
                xs: 24,
                children: {
                  children: [
                    {
                      name: 'title',
                      className: 'block-title',
                      children: '模型沙箱化训练',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content0',
                      className: 'block-content',
                      children:
                        '所有模型训练节点相互隔离，计算资源弹性伸缩。任何节点都不直接访问平台存储，保证数据安全。',
                    },
                    {
                      name: 'content1',
                      className: 'block-content',
                      children: '',
                    },
                  ],
                },
              },
              {
                name: 'block04',
                className: 'block-box',
                md: 8,
                xs: 24,
                children: {
                  children: [
                    {
                      name: 'title',
                      className: 'block-title',
                      children: '企业级集群分布式技术',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content0',
                      className: 'block-content',
                      children:
                        '支持1000+计算节点大规模分布式训练任务，GPU加速比达0.91，大大提高算力资源利用率。',
                    },
                    {
                      name: 'content1',
                      className: 'block-content',
                      children: '',
                    },
                  ],
                },
              },
              {
                name: 'block05',
                className: 'block-box',
                md: 8,
                xs: 24,
                children: {
                  children: [
                    {
                      name: 'title',
                      className: 'block-title',
                      children: '自研模型编译技术',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content0',
                      className: 'block-content',
                      children:
                        '支持将TensorFlow、PyTorch、Keras、MXNet 等主流框架模型快速编译为X86和ARM等CPU架构的运行时文件，并提供高并发高可用的弹性部署环境。',
                    },
                    {
                      name: 'content1',
                      className: 'block-content',
                      children: '',
                    },
                  ],
                },
              },
              {
                name: 'block06',
                className: 'block-box',
                md: 8,
                xs: 24,
                children: {
                  children: [
                    { name: 'title', className: 'block-title', children: '' },
                    {
                      name: 'content0',
                      className: 'block-content',
                      children: '',
                    },
                    {
                      name: 'content1',
                      className: 'block-content',
                      children: '',
                    },
                  ],
                },
              },
            ],
          },
        },
      },
      {
        name: 'content1',
        className: 'block',
        md: 24,
        xs: 24,
        title: {
          className: 'content-title',
          children: '6大模型能力，服务丰富全面',
        },
        children: {
          block: {
            children: [
              {
                name: 'block11',
                className: 'block-box',
                md: 8,
                xs: 24,
                children: {
                  children: [
                    {
                      name: 'title',
                      className: 'block-title',
                      children: '人脸识别',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content0',
                      className: 'block-content',
                      children:
                        '快速检测人脸，并对人脸面部特征进行提取、分析和对比',
                    },
                    {
                      name: 'content1',
                      className: 'block-content',
                      children: '人脸检测、人脸特征、人脸情绪识别',
                    },
                  ],
                },
              },
              {
                name: 'block12',
                className: 'block-box',
                md: 8,
                xs: 24,
                children: {
                  children: [
                    {
                      name: 'title',
                      className: 'block-title',
                      children: 'OCR识别',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content0',
                      className: 'block-content',
                      children:
                        '快速结构化识别通用场景、证照、票据、仪表等文字信息',
                    },
                    {
                      name: 'content1',
                      className: 'block-content',
                      children: '通用场景识别、证件识别票据识别',
                    },
                  ],
                },
              },
              {
                name: 'block13',
                className: 'block-box',
                md: 8,
                xs: 24,
                children: {
                  children: [
                    {
                      name: 'title',
                      className: 'block-title',
                      children: 'NLP智能',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content0',
                      className: 'block-content',
                      children: '提供多种基于语义理解的NLP算法能力',
                    },
                    {
                      name: 'content1',
                      className: 'block-content',
                      children: '命名实体识别、实体关系抽取、文本摘要提取',
                    },
                  ],
                },
              },
              {
                name: 'block14',
                className: 'block-box',
                md: 8,
                xs: 24,
                children: {
                  children: [
                    {
                      name: 'title',
                      className: 'block-title',
                      children: '对话机器人',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content0',
                      className: 'block-content',
                      children:
                        '具备对话意图识别、多轮对话能力的仿真人机交互服务',
                    },
                    {
                      name: 'content1',
                      className: 'block-content',
                      children: '智能客服、智能外呼、智能质检',
                    },
                  ],
                },
              },
              {
                name: 'block15',
                className: 'block-box',
                md: 8,
                xs: 24,
                children: {
                  children: [
                    {
                      name: 'title',
                      className: 'block-title',
                      children: '智能语音',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content0',
                      className: 'block-content',
                      children:
                        '支持语音识别、语音合成、语音转写等智能语音交互能力',
                    },
                    {
                      name: 'content1',
                      className: 'block-content',
                      children: '语音识别、语音合成、实时语音转写',
                    },
                  ],
                },
              },
              {
                name: 'block16',
                className: 'block-box',
                md: 8,
                xs: 24,
                children: {
                  children: [
                    {
                      name: 'title',
                      className: 'block-title',
                      children: '智能视觉',
                    },
                    {
                      name: 'seperator',
                      className: 'title-seperator',
                      children: '',
                    },
                    {
                      name: 'content0',
                      className: 'block-content',
                      children:
                        '利用计算机智能视觉技术分析图像及视频的相关数据',
                    },
                    {
                      name: 'content1',
                      className: 'block-content',
                      children: '图像识别、图像搜索、视频分析',
                    },
                  ],
                },
              },
            ],
          },
        },
      },
    ],
  },
};
